import React, { useState } from "react";

import LivePl from "../LivePl/LivePl";

const fmt = require("indian-number-format");

export default function StandingCard(props) {
  const item = props.item;
  const admin_sharing = item.admin_sharing;

  const [pfdata, setPfdata] = useState([]);

  const [total, setTotal] = useState(0);
  const [admin_total, setAdminTotal] = useState(0);

  const OpenEditSuper = () => {
    window.user_id = item.id;
    window.openeditSuper();
  };

  const LivePlTotal = (a, b, c) => {
    if (item.standing.length > 0) {
      var newpfdata = pfdata;

      if (Array.isArray(newpfdata)) {
        var found = false;

        newpfdata.map((i1, t1) => {
          if (i1.id == a) {
            found = t1;
          }
        });

        if (found === false) {
          newpfdata.push({
            id: a,
            pf: b,
            admin_pf: c,
          });

          var totals = 0;
          var admintotals = 0;

          newpfdata.map((i3) => {
            totals = parseFloat(totals) + parseFloat(i3.pf);
            admintotals = parseFloat(admintotals) + parseFloat(i3.admin_pf);
          });

          setPfdata(newpfdata);
          setTotal(totals);
          setAdminTotal(admintotals);
        } else {
          newpfdata[found].pf = b;
          newpfdata[found].admin_pf = c;

          var totals = 0;
          var admintotals = 0;

          newpfdata.map((i) => {
            totals = parseFloat(totals) + parseFloat(i.pf);
            admintotals = parseFloat(admintotals) + parseFloat(i.admin_pf);
          });

          setPfdata(newpfdata);
          setTotal(totals);
          setAdminTotal(admintotals);
        }
      } else {
        newpfdata.push({
          id: a,
          pf: b,
          admin_pf: c,
        });
        setPfdata(newpfdata);
        setTotal(b);
        setAdminTotal(c);
      }
    }
  };

  let nettotal = parseFloat(
    parseFloat(parseFloat(total) + parseFloat(item.profit_loss)).toFixed(0)
  ).toFixed(0);

  return (
    <li key={item.id} className={`menuContainer text addHight`}>
      {item.standing.length > 0
        ? item.standing.map((i) => {
            return (
              <LivePl
                item={i}
                key={i.id}
                LivePlTotal={LivePlTotal}
                admin_sharing={admin_sharing}
              />
            );
          })
        : null}

      <div onClick={OpenEditSuper} className="menuExchange uppercase">
        <div className="user_id">{item.username}</div>
      </div>
      <div
        className={`menuExchange ${
          item.profit_loss > 0 ? "buytext" : "selltext"
        } `}
      >
        {fmt.format(parseFloat(item.profit_loss).toFixed(0))}
      </div>
      <div className={`menuExchange  ${total > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(parseFloat(total).toFixed(0))}
      </div>
      <div className={`menuExchange  ${nettotal > 0 ? "buytext" : "selltext"}`}>
        {fmt.format(nettotal)}
      </div>

      <div
        className={`menuExchange  ${admin_total <= 0 ? "buytext" : "selltext"}`}
      >
        {fmt.format(parseFloat(Math.abs(admin_total)).toFixed(0))}
      </div>
    </li>
  );
}
